import { linkStyling } from "@made-people/blueprint-link/blueprint";

linkStyling.override({
  slots: {
    wrapper: "relative group/link cursor-pointer inline-flex items-center",
    label: "",
    icon: "size-5 mr-2",
  },
  variants: {
    style: {
      "no-underline": {
        label:
          "after:absolute after:h-px after:bg-current after:w-0 after:left-0 after:-bottom-[0em] after:transition-[width] after:duration-500 after:ease-[cubic-bezier(0.32,0.72,0,1)] after:group-hover/link:w-full",
      },
      underline: {
        label:
          "underline underline-offset-4 group-hover/link:underline-offset-[6px] transition-all",
      },
    },
    size: {
      inherit: {
        wrapper: "",
      },
      sm: {
        wrapper: "text-label-sm",
      },
      md: {
        wrapper: "text-label-md",
      },
      lg: {
        wrapper: "text-label-lg",
      },
      xl: {
        wrapper: "text-label-xl",
      },
    },
  },
});
